import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { $ } from 'protractor';
import { PredialUrbanoService } from 'src/app/Sercivios/predial-urbano.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-consulta-adeudo',
  templateUrl: './consulta-adeudo.component.html',
  styleUrls: ['./consulta-adeudo.component.scss']
})
export class ConsultaAdeudoComponent implements OnInit {

  constructor(private router: Router) { }

  cve_catast = {
    mun: "",
    pob: "",
    cua: "",
    man: "",
    pre: "",
    uni: ""
  }

  es_movil = false;
  mensajeError = '';

  img_ayuda_1: any
  img_ayuda_2: any
  img_ayuda_3: any

  ngOnInit(): void {
    this.cve_catast.mun = environment.cve_municipio
    this.img_ayuda_1 = environment.img_ayuda_1;
    this.img_ayuda_2 = environment.img_ayuda_2;
    this.img_ayuda_3 = environment.img_ayuda_3;
    document.getElementById("pob").focus();

    if (window.innerHeight > window.innerWidth) {
      this.es_movil = true
    } else {
      this.es_movil = false
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (event.target.value.length == 2) {
      switch (event.target.id) {
        case "pob":
          setTimeout(() => {
            document.getElementById("cua").focus();
          }, 100);
          break
        case "cua":
          setTimeout(() => {
            document.getElementById("man").focus();
          }, 100);
          break
        case "man":
          setTimeout(() => {
            document.getElementById("pre").focus();
          }, 100);
          break
        case "pre":
          setTimeout(() => {
            document.getElementById("uni").focus();
          }, 100);
          break
      }
      //document.getElementById("")
    }
    return true;
  }

  // Backspace en un campo vacío → brinca al campo anterior
  prevField(event): void {
    if (event.target.value.length !== 0) {
      return; // hay texto: dejar que el backspace borre normal
    }
    const anterior = {
      cua: "pob",
      man: "cua",
      pre: "man",
      uni: "pre"
    };
    const idAnterior = anterior[event.target.id];
    if (idAnterior) {
      const el = document.getElementById(idAnterior) as HTMLInputElement;
      if (el) {
        el.focus();
        // Cursor al final: así el siguiente Backspace borra un dígito a la vez
        const fin = el.value.length;
        el.setSelectionRange(fin, fin);
      }
    }
  }

  ConsultarAdeudo(): void {
    this.mensajeError = '';
    this.router.navigate(["/Adeudo/" + this.cve_catast.mun + this.cve_catast.pob + this.cve_catast.cua + this.cve_catast.man + this.cve_catast.pre + this.cve_catast.uni])
  }

  SubmitUni(): void {
    const clave = this.cve_catast.mun + this.cve_catast.pob + this.cve_catast.cua +
      this.cve_catast.man + this.cve_catast.pre + this.cve_catast.uni;
    if (clave.length === 18) {
      this.ConsultarAdeudo();
    } else {
      this.mensajeError = 'Verifique su clave catastral';
    }
  }

  private get claveCapturada(): string {
    const c = this.cve_catast;
    return (c.mun || '') + (c.pob || '') + (c.cua || '') + (c.man || '') + (c.pre || '') + (c.uni || '');
  }

  get claveCompleta(): boolean {
    return /^\d{18}$/.test(this.claveCapturada);
  }

  // Vista previa: 022-000-000-000-000-000, con guiones bajos en lo que falta.
  get claveFormateada(): string {
    const c = this.cve_catast;
    return [c.mun, c.pob, c.cua, c.man, c.pre, c.uni]
      .map(seg => ((seg || '') + '___').substring(0, 3))
      .join('-');
  }

  // Pegar la clave completa (18 digitos, o 15 sin municipio) la reparte en los campos.
  PegarClave(event: ClipboardEvent): void {
    const texto = (event.clipboardData || (window as any).clipboardData).getData('text') || '';
    let digitos = texto.replace(/\D/g, '');
    if (digitos.length === 18 && digitos.substring(0, 3) === this.cve_catast.mun) {
      digitos = digitos.substring(3);
    }
    if (digitos.length !== 15) {
      return; // no es una clave completa: se deja el pegado normal
    }
    event.preventDefault();
    this.cve_catast.pob = digitos.substring(0, 3);
    this.cve_catast.cua = digitos.substring(3, 6);
    this.cve_catast.man = digitos.substring(6, 9);
    this.cve_catast.pre = digitos.substring(9, 12);
    this.cve_catast.uni = digitos.substring(12, 15);
    this.mensajeError = '';
    setTimeout(() => document.getElementById('btnconsultar').focus(), 0);
  }

  MostrarModal() {
    //$('#myModal').modal('show')
  }
}
